import React, { ReactElement } from "react";
import styles from "../onlineIndicator/OnlineIndicator.module.scss";

export function OnlineIndicator({
  online,
}: {
  online: boolean;
}): ReactElement | null {
  return (
    <div
      className={`${online ? styles.online : styles.offline} ${styles.onlineIndicator}`}
    ></div>
  );
}
